import loading from "../loading-text/component";

export default class {
  onCreate() {
    this.state = {
      searchResult: null,
    };
  }

  handleSearch({ queryValue, queryLang }) {
    this.state.searchResult = null;
    loading.show();

    // call AI model to classify the type





    const myInit = {
      method: "POST",
      headers: {
        Accept: "application/json",
        ContentType: "application/json; charset=UTF-8",
      },
      mode: "cors",
      cache: "default",
      body: JSON.stringify({ query: queryValue, lang: queryLang }),
    };

    const myRequest = new Request("/search", myInit);
    fetch(myRequest)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.json();
      })
      .then((data) => {
        this.state.searchResult = data;
        loading.close();
      });
  }
}
